if (document.getElementById("rankerd-workflow")) {
    const CONFIG = {
      copy: {
        tagline: "Two follow-ups. One lesson photo.",
        trustLine: "Nothing is sent automatically. Review, edit and share when you are ready.",
        cardHeaders: {
          parentUpdate: "Parent update ~10s",
          assignment: "Assignment ~45s"
        },
        badge: "Auto-graded",
        stamp: "Tutor-reviewed",
        inputChips: ["photo", "PDF", "notes"],
        thumbnailLabel: "Add material",
        parentUpdateLines: [
          "Today we covered …",
          "We stopped at …",
          "Before next class …"
        ],
        editableWord: {
          before: "trinomials",
          after: "word problems"
        },
        quizRows: [
          { q: "Q1", topic: "Discriminant Δ > 0", correctIndex: 1 },
          { q: "Q2", topic: "Vertex form axis", correctIndex: 2 },
          { q: "Q3", topic: "Factoring roots", correctIndex: 0 },
          { q: "Q4", topic: "Word problem area", correctIndex: 3 },
          { q: "Q5", topic: "Parabola intercept", correctIndex: 1 }
        ],
        share: {
          parentAvatar: "Parent",
          studentAvatar: "Student",
          whatsappChip: "WhatsApp",
          linkChip: "Quiz link",
          studentScorePop: "8/10 · result"
        },
        replayButton: "Replay"
      },
      timing: {
        sequenceDuration: 11.0, // 11-second active sequence
        loopPause: 1.0,         // 1-second pause at end before looping
        totalDuration: 12.0     // 12.0s total cycle
      }
    };

    /* ==========================================================================
       2. POPULATE DOM FROM CONFIG & CACHE ELEMENTS
       ========================================================================== */
    (function initRankerdWorkflow() {
      const rootSection = document.getElementById("rankerd-workflow");
      const stage = document.getElementById("rd-stage");

      // Inject copy strings from CONFIG
      document.getElementById("rd-thumb-label").textContent = CONFIG.copy.thumbnailLabel;
      document.getElementById("rd-header-left").textContent = CONFIG.copy.cardHeaders.parentUpdate;
      document.getElementById("rd-header-right").textContent = CONFIG.copy.cardHeaders.assignment;
      document.getElementById("rd-badge-text").textContent = CONFIG.copy.badge;
      document.getElementById("rd-stamp-text").textContent = CONFIG.copy.stamp;
      document.getElementById("rd-trust-text").textContent = CONFIG.copy.trustLine;
      document.getElementById("rd-parent-label").textContent = CONFIG.copy.share.parentAvatar;
      document.getElementById("rd-student-label").textContent = CONFIG.copy.share.studentAvatar;
      document.getElementById("rd-chip-wa-text").textContent = CONFIG.copy.share.whatsappChip;
      document.getElementById("rd-chip-link-text").textContent = CONFIG.copy.share.linkChip;
      document.getElementById("rd-score-text").textContent = CONFIG.copy.share.studentScorePop;
      document.getElementById("rd-tagline").textContent = CONFIG.copy.tagline;
      document.getElementById("rd-replay-label").textContent = CONFIG.copy.replayButton;
      document.getElementById("rd-word-before").textContent = CONFIG.copy.editableWord.before;
      document.getElementById("rd-word-after").textContent = CONFIG.copy.editableWord.after;

      // Populate Parent Update Line Prefixes
      CONFIG.copy.parentUpdateLines.forEach((lineText, idx) => {
        const el = document.getElementById("rd-prefix-" + idx);
        if (el) el.textContent = lineText;
      });

      // Populate Input Chips ("photo", "PDF", "URL") on Whiteboard & Thumbnail Pill
      const wbChipsContainer = document.getElementById("rd-wb-chips");
      const thumbChipsContainer = document.getElementById("rd-thumb-chips");
      CONFIG.copy.inputChips.forEach((chipLabel, idx) => {
        const wbChip = document.createElement("span");
        wbChip.className = "rd-wb-chip";
        if (idx === 0) wbChip.setAttribute("data-active", "true");
        wbChip.textContent = chipLabel;
        wbChipsContainer.appendChild(wbChip);

        const tChip = document.createElement("span");
        tChip.className = "rd-chip";
        if (idx === 0) tChip.setAttribute("data-primary", "true");
        tChip.textContent = chipLabel;
        thumbChipsContainer.appendChild(tChip);
      });

      // Populate 5 MCQ Rows (Q1-Q5, each with 4 option dots)
      const mcqList = document.getElementById("rd-mcq-list");
      const mcqRowElements = [];
      const mcqCheckElements = [];

      CONFIG.copy.quizRows.forEach((row) => {
        const rowEl = document.createElement("div");
        rowEl.className = "rd-mcq-row";

        const leftWrap = document.createElement("div");
        leftWrap.className = "rd-mcq-left";

        const checkBox = document.createElement("span");
        checkBox.className = "rd-quiz-check";
        const checkFill = document.createElement("span");
        checkFill.className = "rd-quiz-check-fill";
        checkFill.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5"><polyline points="20 6 9 17 4 12"/></svg>';
        checkBox.appendChild(checkFill);

        const qLabel = document.createElement("span");
        qLabel.className = "rd-mcq-qlabel";
        qLabel.textContent = row.q;

        const topic = document.createElement("span");
        topic.className = "rd-mcq-topic";
        topic.textContent = row.topic;

        leftWrap.appendChild(checkBox);
        leftWrap.appendChild(qLabel);
        leftWrap.appendChild(topic);

        const dotsWrap = document.createElement("div");
        dotsWrap.className = "rd-mcq-dots";
        for (let d = 0; d < 4; d++) {
          const dot = document.createElement("span");
          dot.className = "rd-dot";
          if (d === row.correctIndex) dot.setAttribute("data-correct", "true");
          dotsWrap.appendChild(dot);
        }

        rowEl.appendChild(leftWrap);
        rowEl.appendChild(dotsWrap);
        mcqList.appendChild(rowEl);

        mcqRowElements.push(rowEl);
        mcqCheckElements.push(checkFill);
      });

      // Cache animated DOM nodes
      const dom = {
        masterBar: document.getElementById("rd-master-bar"),
        whiteboard: document.getElementById("rd-whiteboard"),
        viewfinder: document.getElementById("rd-viewfinder"),
        shutterBeam: document.getElementById("rd-shutter-beam"),
        shutterFlash: document.getElementById("rd-shutter-flash"),
        thumbPill: document.getElementById("rd-thumb-pill"),
        connectors: document.getElementById("rd-connectors"),
        cardLeft: document.getElementById("rd-card-left"),
        cardRight: document.getElementById("rd-card-right"),
        lines: [
          document.getElementById("rd-line-0"),
          document.getElementById("rd-line-1"),
          document.getElementById("rd-line-2")
        ],
        twChunks: Array.from(document.querySelectorAll(".rd-tw-chunk")),
        editableWrap: document.getElementById("rd-editable-wrap"),
        wordBefore: document.getElementById("rd-word-before"),
        wordAfter: document.getElementById("rd-word-after"),
        quizBar: document.getElementById("rd-quiz-bar"),
        mcqRows: mcqRowElements,
        mcqChecks: mcqCheckElements,
        badgeAutograded: document.getElementById("rd-badge-autograded"),
        pointer: document.getElementById("rd-pointer"),
        stamp: document.getElementById("rd-stamp"),
        trustLine: document.getElementById("rd-trust-line"),
        avatarParent: document.getElementById("rd-avatar-parent"),
        avatarStudent: document.getElementById("rd-avatar-student"),
        chipWa: document.getElementById("rd-chip-wa"),
        chipLink: document.getElementById("rd-chip-link"),
        scorePop: document.getElementById("rd-score-pop"),
        tagline: document.getElementById("rd-tagline"),
        stepPills: Array.from(document.querySelectorAll(".rd-step-pill"))
      };

      /* ========================================================================
         3. MATH & EASING HELPERS (60fps transform/opacity interpolation)
         ======================================================================== */
      const clamp01 = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
      const progress = (t, start, end) => clamp01((t - start) / (end - start));
      const lerp = (a, b, p) => a + (b - a) * p;
      const easeOutCubic = (x) => 1 - Math.pow(1 - x, 3);
      const easeInOutCubic = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
      const easeOutBack = (x) => {
        const c1 = 1.70158;
        const c3 = c1 + 1;
        return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
      };

      /* ========================================================================
         4. PURE RENDER FUNCTION FOR TIME `t` (0.0s -> 12.0s)
         Strictly mutates `style.transform` and `style.opacity`
         ======================================================================== */
      function renderAtTime(t) {
        // Master progress bar
        const totalP = clamp01(t / CONFIG.timing.sequenceDuration);
        dom.masterBar.style.transform = `scaleX(${totalP.toFixed(4)})`;

        // Update active step pill indicator
        const activeIdx = t < 2.5 ? 0 : t < 5.8 ? 1 : t < 8.5 ? 2 : 3;
        dom.stepPills.forEach((pill, idx) => {
          const isAct = idx === activeIdx ? "true" : "false";
          if (pill.getAttribute("data-active") !== isAct) {
            pill.setAttribute("data-active", isAct);
          }
        });

        /* ----------------------------------------------------------------------
           SCENE 1: CAPTURE (0.0s -> 2.5s)
           ---------------------------------------------------------------------- */
        const wbEnter = easeOutCubic(progress(t, 0.0, 0.35));
        const wbShrink = easeInOutCubic(progress(t, 1.55, 2.35));
        const wbScale = lerp(0.94, 1.0, wbEnter) * lerp(1.0, 0.22, wbShrink);
        const wbY = lerp(18, 0, wbEnter) + lerp(0, -175, wbShrink);
        const wbOpacity = wbEnter * (1 - easeOutCubic(progress(t, 1.95, 2.35)));
        dom.whiteboard.style.opacity = wbOpacity.toFixed(3);
        dom.whiteboard.style.transform = `translate3d(0, ${wbY.toFixed(1)}px, 0) scale(${wbScale.toFixed(3)})`;

        // Camera Viewfinder & Shutter Sweep (0.45s -> 1.45s)
        const vfIn = easeOutCubic(progress(t, 0.4, 0.65));
        const vfOut = 1 - progress(t, 1.35, 1.6);
        const vfOpacity = vfIn * vfOut;
        const vfScale = lerp(1.06, 1.0, vfIn);
        dom.viewfinder.style.opacity = vfOpacity.toFixed(3);
        dom.viewfinder.style.transform = `scale(${vfScale.toFixed(3)})`;

        const sweepP = easeInOutCubic(progress(t, 0.55, 1.25));
        const sweepOpacity = (t >= 0.55 && t <= 1.3) ? 1 : 0;
        dom.shutterBeam.style.opacity = sweepOpacity;
        dom.shutterBeam.style.transform = `translate3d(0, ${lerp(-60, 260, sweepP).toFixed(1)}px, 0)`;

        // Quick camera shutter flash at 1.25s
        const flashIn = progress(t, 1.2, 1.28);
        const flashOut = 1 - progress(t, 1.28, 1.55);
        dom.shutterFlash.style.opacity = (flashIn * flashOut * 0.75).toFixed(3);

        // Top Thumbnail Pill ("Add material") appears as whiteboard shrinks
        const thumbP = easeOutBack(progress(t, 1.85, 2.45));
        dom.thumbPill.style.opacity = clamp01(progress(t, 1.85, 2.25)).toFixed(3);
        dom.thumbPill.style.transform = `translate3d(0, ${lerp(14, 0, thumbP).toFixed(1)}px, 0) scale(${lerp(0.85, 1, thumbP).toFixed(3)})`;

        /* ----------------------------------------------------------------------
           SCENE 2: GENERATE (2.5s -> 5.8s)
           ---------------------------------------------------------------------- */
        const connP = easeOutCubic(progress(t, 2.45, 2.85));
        dom.connectors.style.opacity = connP.toFixed(3);
        dom.connectors.style.transform = `scaleY(${lerp(0.3, 1, connP).toFixed(3)})`;

        // Left & Right Parallel Cards split out
        const leftCardP = easeOutCubic(progress(t, 2.55, 3.05));
        dom.cardLeft.style.opacity = leftCardP.toFixed(3);
        dom.cardLeft.style.transform = `translate3d(${lerp(24, 0, leftCardP).toFixed(1)}px, ${lerp(16, 0, leftCardP).toFixed(1)}px, 0) scale(${lerp(0.95, 1, leftCardP).toFixed(3)})`;

        const rightCardP = easeOutCubic(progress(t, 2.68, 3.18));
        dom.cardRight.style.opacity = rightCardP.toFixed(3);
        dom.cardRight.style.transform = `translate3d(${lerp(-24, 0, rightCardP).toFixed(1)}px, ${lerp(16, 0, rightCardP).toFixed(1)}px, 0) scale(${lerp(0.95, 1, rightCardP).toFixed(3)})`;

        // Left Card: 3 Parent Update Lines + Typewriter Chunks
        const lineStarts = [3.0, 3.75, 4.5];
        dom.lines.forEach((lineEl, idx) => {
          const lp = easeOutCubic(progress(t, lineStarts[idx], lineStarts[idx] + 0.35));
          lineEl.style.opacity = lp.toFixed(3);
          lineEl.style.transform = `translate3d(0, ${lerp(6, 0, lp).toFixed(1)}px, 0)`;
        });

        dom.twChunks.forEach((chunk, idx) => {
          const start = 3.15 + idx * 0.19;
          const cp = easeOutCubic(progress(t, start, start + 0.22));
          chunk.style.opacity = cp.toFixed(3);
          chunk.style.transform = `translate3d(0, ${lerp(3, 0, cp).toFixed(1)}px, 0)`;
        });

        // Right Card: Shimmer Progress Bar (3.0s -> 4.9s)
        const barP = easeInOutCubic(progress(t, 3.0, 4.9));
        dom.quizBar.style.transform = `scaleX(${barP.toFixed(4)})`;

        // Right Card: 5 Staggered MCQ Rows
        dom.mcqRows.forEach((rowEl, idx) => {
          const rStart = 3.15 + idx * 0.32;
          const rp = easeOutCubic(progress(t, rStart, rStart + 0.35));
          rowEl.style.opacity = rp.toFixed(3);
          rowEl.style.transform = `translate3d(${lerp(12, 0, rp).toFixed(1)}px, 0, 0)`;
        });

        // Right Card: "Auto-graded" Badge pops in at 5.05s
        const badgeP = easeOutBack(progress(t, 5.05, 5.55));
        const badgeOp = clamp01(progress(t, 5.05, 5.3));
        dom.badgeAutograded.style.opacity = badgeOp.toFixed(3);
        dom.badgeAutograded.style.transform = `scale(${lerp(0.5, 1, badgeP).toFixed(3)})`;

        /* ----------------------------------------------------------------------
           SCENE 3: REVIEW (5.8s -> 8.5s)
           ---------------------------------------------------------------------- */
        // Tutor Pointer trajectory:
        // 5.8s -> 6.3s: Enters toward highlighted word on left card
        // 6.3s -> 6.65s: Clicks & swaps word
        // 6.65s -> 7.2s: Glides across to right card checkboxes
        // 7.2s -> 7.9s: Ticks down quiz rows
        // 7.9s -> 8.3s: Fades out
        const ptrIn = easeOutCubic(progress(t, 5.8, 6.3));
        const ptrToQuiz = easeInOutCubic(progress(t, 6.65, 7.2));
        const ptrSweepDown = easeInOutCubic(progress(t, 7.2, 7.85));
        const ptrOut = 1 - progress(t, 7.95, 8.3);

        let ptrX = lerp(380, 195, ptrIn);
        let ptrY = lerp(330, 218, ptrIn);
        if (t > 6.65) {
          ptrX = lerp(195, 520, ptrToQuiz);
          ptrY = lerp(218, 175, ptrToQuiz) + lerp(0, 110, ptrSweepDown);
        }
        // Subtle click press scale at 6.4s
        const clickPulse = (t > 6.32 && t < 6.55) ? 0.86 : 1.0;
        dom.pointer.style.opacity = (clamp01( progress(t, 5.8, 6.05) ) * ptrOut).toFixed(3);
        dom.pointer.style.transform = `translate3d(${ptrX.toFixed(1)}px, ${ptrY.toFixed(1)}px, 0) scale(${clickPulse})`;

        // Word Swap on Left Card at 6.45s
        const swapP = easeOutCubic(progress(t, 6.4, 6.75));
        dom.wordBefore.style.opacity = (1 - swapP).toFixed(3);
        dom.wordBefore.style.transform = `translate3d(0, ${lerp(0, -5, swapP).toFixed(1)}px, 0)`;
        dom.wordAfter.style.opacity = swapP.toFixed(3);
        dom.wordAfter.style.transform = `translate3d(0, ${lerp(5, 0, swapP).toFixed(1)}px, 0)`;
        dom.editableWrap.setAttribute("data-swapped", t >= 6.48 ? "true" : "false");

        // Quiz Checkboxes tick staggered (7.15s -> 7.85s)
        dom.mcqChecks.forEach((chk, idx) => {
          const cStart = 7.15 + idx * 0.12;
          const cp = easeOutBack(progress(t, cStart, cStart + 0.25));
          const cop = clamp01(progress(t, cStart, cStart + 0.15));
          chk.style.opacity = cop.toFixed(3);
          chk.style.transform = `scale(${lerp(0.4, 1, cp).toFixed(3)})`;
        });

        // "Tutor-reviewed" Stamp scales in at 7.65s
        const stampP = easeOutBack(progress(t, 7.65, 8.1));
        const stampOp = clamp01(progress(t, 7.65, 7.9));
        dom.stamp.style.opacity = stampOp.toFixed(3);
        dom.stamp.style.transform = `rotate(-8deg) scale(${lerp(1.6, 1.0, stampP).toFixed(3)})`;

        // Trust Line fades in at 7.75s
        const trustP = easeOutCubic(progress(t, 7.75, 8.25));
        dom.trustLine.style.opacity = trustP.toFixed(3);
        dom.trustLine.style.transform = `translate3d(0, ${lerp(8, 0, trustP).toFixed(1)}px, 0)`;

        /* ----------------------------------------------------------------------
           SCENE 4: SHARE (8.5s -> 11.0s, hold to 12.0s)
           ---------------------------------------------------------------------- */
        const avatarP = easeOutCubic(progress(t, 8.5, 8.95));
        dom.avatarParent.style.opacity = avatarP.toFixed(3);
        dom.avatarParent.style.transform = `translate3d(0, ${lerp(10, 0, avatarP).toFixed(1)}px, 0) scale(${lerp(0.94, 1, avatarP).toFixed(3)})`;
        dom.avatarStudent.style.opacity = avatarP.toFixed(3);
        dom.avatarStudent.style.transform = `translate3d(0, ${lerp(10, 0, avatarP).toFixed(1)}px, 0) scale(${lerp(0.94, 1, avatarP).toFixed(3)})`;

        // Green WhatsApp chip flies from left card down to Parent avatar (8.75s -> 9.55s)
        const waFly = easeInOutCubic(progress(t, 8.75, 9.55));
        const waIn = clamp01(progress(t, 8.75, 8.95));
        const waOut = 1 - clamp01(progress(t, 9.45, 9.68));
        dom.chipWa.style.opacity = (waIn * waOut).toFixed(3);
        dom.chipWa.style.transform = `translate3d(${lerp(-25, 0, waFly).toFixed(1)}px, ${lerp(-78, 0, waFly).toFixed(1)}px, 0) scale(${lerp(1, 0.85, waFly).toFixed(3)})`;

        // Link chip flies from right card down to Student avatar (8.9s -> 9.7s)
        const linkFly = easeInOutCubic(progress(t, 8.9, 9.7));
        const linkIn = clamp01(progress(t, 8.9, 9.1));
        const linkOut = 1 - clamp01(progress(t, 9.6, 9.82));
        dom.chipLink.style.opacity = (linkIn * linkOut).toFixed(3);
        dom.chipLink.style.transform = `translate3d(${lerp(-25, 0, linkFly).toFixed(1)}px, ${lerp(-78, 0, linkFly).toFixed(1)}px, 0) scale(${lerp(1, 0.85, linkFly).toFixed(3)})`;

        // Score Pop ("8/10 · ranked") on Student side (9.7s -> 10.15s)
        const scoreP = easeOutBack(progress(t, 9.7, 10.15));
        const scoreOp = clamp01(progress(t, 9.7, 9.95));
        dom.scorePop.style.opacity = scoreOp.toFixed(3);
        dom.scorePop.style.transform = `translate3d(0, ${lerp(6, 0, scoreP).toFixed(1)}px, 0) scale(${lerp(0.5, 1, scoreP).toFixed(3)})`;

        // Tagline ("Two follow-ups. One lesson photo.") fades in prominently (10.0s -> 10.55s)
        const tagP = easeOutCubic(progress(t, 10.0, 10.55));
        dom.tagline.style.opacity = tagP.toFixed(3);
        dom.tagline.style.transform = `translate3d(0, ${lerp(8, 0, tagP).toFixed(1)}px, 0)`;
      }

      /* ========================================================================
         5. MASTER TIMELINE CONTROLLER (IntersectionObserver + Hover Pause + Replay)
         ======================================================================== */
      let elapsed = 0; // seconds (0 -> 12)
      let lastFrameTime = null;
      let isInView = false;
      let isHovered = false;
      let isReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      let rafId = null;

      function tick(now) {
        if (lastFrameTime === null) lastFrameTime = now;
        const dt = (now - lastFrameTime) / 1000;
        lastFrameTime = now;

        if (isInView && !isHovered && !isReducedMotion) {
          elapsed = (elapsed + dt) % CONFIG.timing.totalDuration;
          renderAtTime(elapsed);
        }

        if (isInView) rafId = requestAnimationFrame(tick);
        else rafId = null;
      }

      // Start only when scrolled into view
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isInView = entry.isIntersecting;
            if (isInView && !rafId) {
              lastFrameTime = null;
              rafId = requestAnimationFrame(tick);
            }
          });
        },
        { threshold: 0.25 }
      );
      observer.observe(rootSection);

      // Pause on hover
      stage.addEventListener("mouseenter", () => {
        isHovered = true;
        rootSection.setAttribute("data-paused", "true");
      });
      stage.addEventListener("mouseleave", () => {
        isHovered = false;
        rootSection.setAttribute("data-paused", "false");
      });

      rootSection.addEventListener("focusin", () => { isHovered = true; rootSection.setAttribute("data-paused", "true"); });
      rootSection.addEventListener("focusout", (event) => { if (!rootSection.contains(event.relatedTarget)) { isHovered = false; rootSection.setAttribute("data-paused", "false"); } });

      // Accessible Replay Button
      const replayBtn = document.getElementById("rd-replay-btn");
      replayBtn.addEventListener("click", () => {
        elapsed = 0.6;
        isHovered = false;
        rootSection.setAttribute("data-paused", "false");
        lastFrameTime = null;
        renderAtTime(elapsed);
      });

      // Step Pill Jump Buttons
      dom.stepPills.forEach((pill) => {
        pill.addEventListener("click", () => {
          const jumpTime = parseFloat(pill.getAttribute("data-scene-jump")) || 0;
          elapsed = jumpTime;
          lastFrameTime = null;
          renderAtTime(elapsed);
        });
      });

      // Listen for OS prefers-reduced-motion changes
      const motionMedia = window.matchMedia("(prefers-reduced-motion: reduce)");
      motionMedia.addEventListener("change", (e) => {
        isReducedMotion = e.matches;
        if (isReducedMotion) {
          renderAtTime(CONFIG.timing.sequenceDuration);
        }
      });

      // Initial render
      renderAtTime(isReducedMotion ? CONFIG.timing.sequenceDuration : 0);

    })();
}
